export default {
  TITLE: '404',
  SUBTITLE: 'Ops! Você está perdido. =(',
  DESCRIPTION: 'A página que você está procurando não foi encontrada.',
};
